import { VueMasonryPlugin } from './masonry.plugin.js'

export default VueMasonryPlugin

export { VueMasonryPlugin }
